import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { projects } from '../../projectsData';
import ProjectDetails from './ProjectDetails';
import CodeOHProjectDetails from './CodeOHProjectDetails';
import NL2SQLProjectDetails from './NL2SQLProjectDetails';
import TransformerProjectDetails from './TransformerProjectDetails';
import IndoorNavProjectDetails from './IndoorNavProjectDetails';
import PandasTAProjectDetails from './PandasTAProjectDetails';

const ProjectRoute: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const project = projects.find(p => p.slug === slug);

  if (!project) {
    return <Navigate to="/projects" replace />;
  }

  const onClose = () => navigate('/projects');

  switch (project.slug) {
    case 'codeoh':
      return <CodeOHProjectDetails project={project} onClose={onClose} />;
    case 'natural-language-to-sql':
      return <NL2SQLProjectDetails project={project} onClose={onClose} />;
    case 'transformer-language-modelling':
      return <TransformerProjectDetails project={project} onClose={onClose} />;
    case 'indoor-nav':
      return <IndoorNavProjectDetails project={project} onClose={onClose} />;
    case 'pandas-ta':
      return <PandasTAProjectDetails project={project} onClose={onClose} />;
    default:
      return <ProjectDetails project={project} onClose={onClose} />;
  }
};

export default ProjectRoute;
